import React from 'react';
import { Text } from '@components/typography';
import { MenuWrapper, StyledLink } from './NewsroomHeaderSection.styles';
import { SpacingStack } from '@components/SpacingStack';
import { Box } from '@components/Box';
import { Columns } from '@components/Columns';

export const NewsroomHeaderSection = () => {
  const onClick = (e: React.MouseEvent<HTMLElement>) => {
    const id = e.currentTarget.dataset.scroll;
    if (id) {
      const elmnt = document.getElementById(id);
      elmnt?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  };

  return (
    <Box marginTop={[12]}>
      <SpacingStack spacing={7}>
        <Text color="purple6" variant="hed72Hero" tagName="h1" style={{ textAlign: 'center' }}>
          In the News
        </Text>
        <MenuWrapper>
          <Columns centered={true}>
            <Columns.Column width="one-third">
              <StyledLink tabIndex={0} role="button" onClick={onClick} data-scroll="featured-coverage">
                <Text variant="dek20" tagName="span">
                  Featured Coverage
                </Text>
              </StyledLink>
            </Columns.Column>
            <Columns.Column width="one-third">
              <StyledLink tabIndex={0} role="button" onClick={onClick} data-scroll="announcements">
                <Text variant="dek20" tagName="span">
                  Announcements
                </Text>
              </StyledLink>
            </Columns.Column>
            <Columns.Column width="one-third">
              <StyledLink tabIndex={0} role="button" onClick={onClick} data-scroll="brand-assets">
                <Text variant="dek20" tagName="span">
                  Brand Assets
                </Text>
              </StyledLink>
            </Columns.Column>
          </Columns>
        </MenuWrapper>
      </SpacingStack>
    </Box>
  );
};
